export default __webpack_public_path__ + "images/688f3778769a7fec878ded00d92175fa-design.webp";